<script lang="ts">
    import { get } from 'svelte/store';
    import { onMount, afterUpdate } from 'svelte';
    import { _ } from 'svelte-i18n';

    import ErrorInline from '../../shared/ErrorInline.svelte';
    import MessageInline from '../../shared/Messages/MessageInline.svelte';
    import { runOnlyWithStartPlanning } from './StartPlanning';
    import ButtonSmallBlue from '../../shared/ButtonSmallBlue.svelte';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import { debug, deliveryList, planning } from '../../../stores/store';
    import { AssignmentApi, AssignmentRequestSchema } from './AssignmentApi';
    import { Assignment } from './Assignment';
    import { api } from '../../../stores/api';
    import { ScenarioApi } from './ScenarioApi';
    import SelectRouteStartTime from './PageDeliveries2/SelectRouteStartTime.svelte';
    import ProgressBar from '../../shared/ProgressBar.svelte';
    import ButtonSmallBlueRounded from '../../shared/ButtonSmallBlueRounded.svelte';
    import IconRoute from '../../shared/Icons/IconRoute.svelte';
    import IconError from '../../shared/Icons/IconError.svelte';
    import SuccessColor from '../../shared/SuccessColor.svelte';
    import WarningColor from '../../shared/WarningColor.svelte';
    import cancelIconSrc from '../../shared/Icons/svg/close_FILLF_wght400_GRAD0_opsz24.svg';
    import commitIconSrc from '../../shared/Icons/svg/done_FILLF_wght400_GRAD0_opsz24.svg';
    import recalculateIconSrc from '../../shared/Icons/svg/refresh_24dp_FILL0_wght400_GRAD0_opsz24.svg';
    import IconWarning from '../../shared/Icons/IconWarning.svelte';
    import { AssignmentBulkActions } from './AssignmentBulkActions';
    import { DeliveriesBulkActions } from './PageDeliveries2/DeliveriesBulkActions';
    import { rsa } from './PageDeliveries2/RouteSummaryApp/rsa';
    import ToggleRouteLockIcon from './ToggleRouteLockIcon.svelte';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import { features } from '../../shared/Features/features';
    import { dla } from './PageDeliveries2/DeliveryListApp/dla';
    import { scenarioManager, readonlyMode } from '../../../stores/store';
    import { Umami } from '../../utilities/Umami';
    import { RouteSummaryApp } from './PageDeliveries2/RouteSummaryApp/RouteSummaryApp';

    export let assignment: Assignment;
    // export let onFinish: (success: boolean) => void = () => {};
    // export let onStart: () => void = () => {};

    export let extendedVersion: boolean = false;
    export let lockAssignmentAfterCalculation: boolean = false;
    export let showButtonCalc: boolean = true;
    export let showButtonSend: boolean = true;
    export let showButtonOptimize: boolean = false;
    export let showButtonReverse: boolean = false;
    export let displayMode: 'small' | 'standard' = 'standard';
    export let onStartCalc: () => void = () => {};
    export let onFinishCalc: () => void = () => {};
    export let onChangeStartTime: (selectedHour: string) => boolean = () => true;
    export let disabled: boolean = false;

    let textCalcRoute = lockAssignmentAfterCalculation ? 'Send' : 'Calc route';

    let calculatingRouteInProgress: boolean = false;
    let handler: any;
    let currentMiliseconds: number = 3000;
    let error: string = '';
    let routeProgress: number = 0;
    let locking: boolean = false;

    let bindedToCurrent = assignment.getId() === $deliveryList.currentAssignment?.getId();

    async function calcRoute2(lock: boolean = true, forceRecalc: boolean = false) {
        console.log('calcRoute, calcRoute2');
        calculatingRouteInProgress = true;
        assignment = assignment.setBusy(true);
        if (assignment.getRouteId() === null || forceRecalc) {
            assignment.setRouteInfoInProgress();
            if (forceRecalc) {
                await assignment.prepareRouteForRecalculation();
            }
            assignment = assignment;
            await AssignmentBulkActions.calculateRoute2(
                $api,
                assignment.getId(),
                assignment.getScenarioId(),
                data => {
                    if (!bindedToCurrent || assignment.getId() === $deliveryList.currentAssignment?.getId()) {
                        assignment.set(data);
                        assignment = assignment;
                    }
                }
            );
        } else {
            console.warn('calcRoute2 - calc route is ignored due to existing route id');
        }
        if (assignment.isRouteCalculated()) {
            Umami.event('route_calculated', { assignment_id: assignment.getId() });
        }
        if (lock) {
            await lockAssignment();
            if (assignment.isRouteCalculated()) {
                Umami.event('route_send_to_driver', { assignment_id: assignment.getId() });
            }
        }
        calculatingRouteInProgress = false;
        if (!bindedToCurrent || assignment.getId() === $deliveryList.currentAssignment?.getId()) {
            assignment = assignment.setBusy(false);
        } else {
            assignment.setBusy(false);
        }
        console.log('calcRoute, calcRoute2, not busy');
        $scenarioManager.updateAssignment(assignment.get());
    }

    async function recalcRoute() {
        routeProgress = 0;
        let routeInfo = assignment.getRouteInfo();
        if (routeInfo && routeInfo.progress) {
            routeInfo.progress.percent = 0;
            assignment.setRouteInfo(routeInfo);
            assignment = assignment;
        }
        locking = true;
        if ($deliveryList.currentAssignment?.getId() === assignment.getId()) {
            $dla.loading = true;
        }
        console.log('CalcRoute, Optimize');
        await calcRoute2(false, true);
        // await assignment.reload();
        if ($deliveryList.currentAssignment?.getId() === assignment.getId()) {
            $dla.resetStatus(true);
            $dla = $dla;
            $deliveryList.triggerReload = true;
        }
        locking = false;
    }

    async function reverseRoute() {
        $rsa.executeAction(
            RouteSummaryApp.ROUTE_MODIFIED_BY_OPERATOR_REVERSE,
            () => {}
        );
    }

    function updateRouteSummary() {
        //$rsa = $rsa.startLoading();
        $rsa.reload(assignment);
    }

    async function lockAssignment() {
        console.log('CalcRouteButton, lockAssignment', assignment.isRouteCalculated());
        calculatingRouteInProgress = true;
        if (assignment.isRouteCalculated()) {
            await AssignmentBulkActions.lockAssignment(assignment.getId());
            if (!bindedToCurrent || assignment.getId() === $deliveryList.currentAssignment?.getId()) {
                assignment = await assignment.reload();
            }
        }
        calculatingRouteInProgress = false;
    }

    function forceReload() {
        console.log('CalcRouteButton', 'forceReload', currentMiliseconds);
        if (handler) clearTimeout(handler);
        AssignmentApi.getOneWithCounters(get(api), assignment.getId())
            .then(response => {
                assignment.setRouteInfo(response?.route_info);
                assignment = assignment;
                if (assignment.isRouteCalculated()) {
                    // if (handler) clearTimeout(handler);
                    calculatingRouteInProgress = false;
                    // updateRouteSummary();
                    // $deliveryList.triggerReload = true;
                } else {
                    if (assignment.isRouteCalculationFailed()) {
                        // if (handler) clearTimeout(handler);
                        console.warn(
                            'CalcRouteButton, route calculation failed',
                            assignment.getId()
                        );
                        Umami.event('route_calculation_failed', { assignment_id: assignment.getId() });
                        calculatingRouteInProgress = false;
                    } else {
                        handler = setTimeout(forceReload, currentMiliseconds);
                    }
                }
            })
            .catch(err => {
                console.error('CalcRouteButton, error', err);
                error = err;
                // if (handler) clearTimeout(handler);
                calculatingRouteInProgress = false;
            });
    }

    onMount(() => {
        if (assignment.isRouteInCalculation()) {
            calculatingRouteInProgress = true;
            // console.log('CalcRouteButton, onMount, route assignment is in calculation, retrying...', assignment.getId());
            handler = setTimeout(
                forceReload,
                currentMiliseconds + Math.floor((Math.random() * currentMiliseconds) / 2)
            );
        }

        return () => {
            // console.log('CalcRouteButton, onMount, clear timeout');
            if (handler) clearTimeout(handler);
        };
    });

    afterUpdate(() => {
        if (assignment.getRouteInfo()) {
            let routeStateChanged = assignment.isRouteInCalculation() != calculatingRouteInProgress;
            calculatingRouteInProgress = assignment.isRouteInCalculation();
            if (routeStateChanged && !handler) {
                handler = setTimeout(
                    forceReload,
                    currentMiliseconds + Math.floor((Math.random() * currentMiliseconds) / 2)
                );
            }
            if (calculatingRouteInProgress) {
                routeProgress = assignment.getRouteCalculationProgressAsNumber();
            }
        }
    });

    $: {
        assignment = assignment;
        calculatingRouteInProgress = assignment.isRouteInCalculation();
    }

    $: {
        if (calculatingRouteInProgress) {
            console.log(
                'CalcRouteButton, triggering 1',
                calculatingRouteInProgress,
                assignment.hasVehicleAssigned(),
                assignment.isRouteCalculated()
            );
            if (handler) clearTimeout(handler);
            handler = setTimeout(
                forceReload,
                currentMiliseconds + Math.floor((Math.random() * currentMiliseconds) / 2)
            );
        } else {
            // console.log(
            //     'CalcRouteButton, else triggering 2',
            //     calculatingRouteInProgress,
            //     assignment.hasVehicleAssigned(),
            //     assignment.isRouteCalculated()
            // );
        }

        if (
            $planning.currentAssignmentLockToggleIcon &&
            typeof $planning.currentAssignmentLockToggleIcon.isLoading == 'function'
        ) {
            locking = $planning.currentAssignmentLockToggleIcon.isLoading();
        }
    }

    $: {
        console.log('CalcRouteButton, showButtonOptimize', showButtonOptimize);
        showButtonOptimize = showButtonOptimize;
    }
</script>

{#if extendedVersion && $debug}
    assignment.isDownloaded(): {assignment.isDownloaded()}<br />
    assignment.isRouteModifiedAfterDownload(): {assignment.isRouteModifiedAfterDownload()}<br />
    $deliveryList.isRouteVariantVisible: {$deliveryList.isRouteVariantVisible}<br />
    locking: {locking}<br />
    showButtonOptimize: {showButtonOptimize}<br />
{/if}
<div class="container" class:extendedVersion>
    {#if assignment.isDownloaded()}
        <div></div>
    {:else if assignment.isLocked()}
        <div></div>
    {:else if assignment.isRouteModifiedAfterDownload()}
        {#if !locking && !$deliveryList.isRouteVariantVisible && extendedVersion}
            <WarningColor>
                <span style="font-size: var(--font-size-tactical-plan);">
                    <MessageInline
                        text={$_(
                            'route-uncommited-modifications' +
                                (assignment.isRouteInvalid() ? '-invalid' : '')
                        )}
                        opacity={1}
                    />
                </span>
            </WarningColor>
            <ButtonSmallBlack
                text={$_('Discard')}
                {disabled}
                showIcon={cancelIconSrc}
                alignIcon={'left'}
                minWidth={80}
                on:click={() => {
                    locking = true;
                    AssignmentApi.discardRouteModifications(get(api), assignment.getId()).then(
                        data => {
                            assignment.set(data);
                            assignment = assignment;
                            updateRouteSummary();
                            forceReload();
                        }
                    );
                }}
            />
            <ButtonSmallBlue
                text={$_(assignment.isRouteInvalid() ? 'Recalculate' : 'Lock')}
                disabled={!assignment.isRouteCalculated() || disabled}
                showIcon={assignment.isRouteInvalid() ? recalculateIconSrc : commitIconSrc}
                alignIcon={'left'}
                minWidth={80}
                on:click={() => {
                    if (assignment.isRouteInvalid()) {
                        recalcRoute();
                    } else {
                        locking = true;
                        $planning.currentAssignmentLockToggleIcon?.toggleLocked();
                        lockAssignment();
                    }
                }}
            />
        {/if}
    {:else if calculatingRouteInProgress || assignment.isBusy()}
        {#if displayMode === 'small'}
            <div
                style="display: flex; align-items: center; flex-direction: row; justify-content: center; column-gap: 6px; "
            >
                <!--                            <div>{routeProgress}%</div>-->
                <IconPending scale={0.6} spin={true} />
            </div>
        {:else}
            <ProgressBar current={routeProgress} compactMode={true} />
        {/if}
    {:else}
        {#if extendedVersion && assignment && assignment.getVehicle()?.route_optimize}
            <SelectRouteStartTime
                bind:assignment
                updateServer={true}
                disabled={assignment.isRouteInCalculation() || disabled || $readonlyMode}
                onChange={selectedHour => {
                    onChangeStartTime(selectedHour);
                    return true;
                }}
            />
        {/if}

        {#if assignment.isRouteCalculationFailed() || error}
            <ErrorInline text={$_('Route failed')} />
        {/if}

        {#if assignment.isRouteCalculated()}
            {#if showButtonCalc && showButtonSend && !locking}
                <ButtonSmallBlueRounded
                    {disabled}
                    text={$_('Send')}
                    dataId="send-only"
                    {displayMode}
                    on:click={() => {
                        console.log('CalcRoute, click3');
                        locking = true;
                        $planning.currentAssignmentLockToggleIcon?.toggleLocked();
                        lockAssignment();
                        //calcRoute2(true);
                    }}
                />
            {:else if !locking}
                {#if showButtonOptimize}
                    <ButtonSmallBlueRounded
                        colorMode="green"
                        {disabled}
                        text={$_('Optimize')}
                        dataId="route-optimize"
                        {displayMode}
                        on:click={() => {
                            recalcRoute();
                        }}
                    />
                {/if}
                {#if showButtonReverse}
                    <ButtonSmallBlueRounded
                        {disabled}
                        text={$_('Reverse')}
                        dataId="route-reverse"
                        {displayMode}
                        on:click={() => {
                            reverseRoute();
                        }}
                    />
                {/if}
            {:else if $debug}
                <div data-desc="">
                    showButtonCalc: {showButtonCalc}, lockAssignmentAfterCalculation: {lockAssignmentAfterCalculation},
                    showButtonSend: {showButtonSend}, locking: {locking}
                </div>
            {/if}
        {:else if !assignment.hasVehicleAssigned()}
            <div style="display: none">
                <MessageInline text={$_('No vehicle')} />
            </div>
        {:else if assignment.getCountDeliveries() > assignment.getMaxDeliveriesPerRoute()}
            {#if extendedVersion}
                <ErrorInline
                    text={$_('Route cannot have more than {count} deliveries', {
                        values: { count: assignment.getMaxDeliveriesPerRoute() },
                    })}
                />
            {:else}
                <!--                <ErrorInline-->
                <!--                    text={$_('Max deliveries: {count}', {-->
                <!--                        values: { count: assignment.getMaxDeliveriesPerRoute() },-->
                <!--                    })}-->
                <!--                />-->
            {/if}
        {:else if assignment.getCountDeliveries() <= 0}
            <div>
                {#if $debug}NO DELIVERIES{/if}
            </div>
        {:else if assignment.isBusy()}
            <div>
                {#if $debug}BUSY{/if}
            </div>
        {:else if assignment.canRouteBeCalculated() || assignment.isRouteCalculated()}
            <!-- `Calc route` + `Send` -->
            {#if (showButtonCalc && showButtonSend) || !lockAssignmentAfterCalculation}
                <ButtonSmallBlueRounded
                    {disabled}
                    {displayMode}
                    dataId="calc-and-send-route"
                    text={$_(assignment.getVehicle()?.route_optimize ? textCalcRoute : 'Set stops')}
                    on:click={async () => {
                        calculatingRouteInProgress = true;
                        $dla.loading = true;
                        if (typeof onStartCalc === 'function') onStartCalc();
                        console.log('CalcRoute, click2');
                        await calcRoute2(lockAssignmentAfterCalculation);
                        if (typeof onFinishCalc === 'function') onFinishCalc();
                    }}
                />
            {/if}
        {:else}
            <MessageInline text={$_('Route cannot be calculated')} />
        {/if}
    {/if}
</div>

<style>
    .container {
        display: flex;
        align-items: center;
        flex-direction: row;
        column-gap: 10px;
        font-size: var(--font-size-tactical-plan);
    }
    .container.extendedVersion {
        /*min-width: 320px;*/
    }
</style>
